export function customFetch(url, request = null) {
    if (request == null)
        request = { method: "GET" };
    request.credentials = "include";
    request.mode = "cors";
    return fetch(url, request).then(async (response) => {
        if (!response.ok) {
            let text = await response.text();
            throw new Error(response.status + " " + response.statusText + ": " + text);
        }
        else {
            return response;
        }
    });
}
